import Model from '@/core/models/Model';

export default class Attribute extends Model {
  resource() {
    return 'app/professional-attributes';
  }
}
